import { useState } from 'react';
import styles from './FlowModal.module.css';
import IdentifyStep from './steps/IdentifyStep';
import ConsentTypeStep from './steps/ConsentTypeStep';
import SelfConsentFormStep from './steps/SelfConsentFormStep';
import GuardianConsentFormStep from './steps/GuardianConsentFormStep';
import ConsentCompleteStep from './steps/ConsentCompleteStep';

const STEPS = {
  IDENTIFY: 'IDENTIFY',
  CONSENT_TYPE: 'CONSENT_TYPE',
  SELF_CONSENT_FORM: 'SELF_CONSENT_FORM',
  GUARDIAN_CONSENT_FORM: 'GUARDIAN_CONSENT_FORM',
  CONSENT_COMPLETE: 'CONSENT_COMPLETE',
};

function FlowModal({ onClose }) {
  const [state, setState] = useState({
    currentStep: STEPS.IDENTIFY,
    seniorInfo: null,
    seniorId: null,
    checkResult: null,
    isNewConsent: false,
  });

  const go = (step, patch = {}) =>
    setState(prev => ({ ...prev, currentStep: step, ...patch }));

  const handleIdentifyDone = (checkResult, seniorInfo) => {
    if (checkResult.hasSelfConsent) {
      go(STEPS.CONSENT_COMPLETE, { checkResult, seniorInfo, seniorId: checkResult.seniorId, isNewConsent: false });
      return;
    }
    // hasConsent: false → 동의 이력 없음 → 동의 유형 선택
    go(STEPS.CONSENT_TYPE, { checkResult, seniorInfo, seniorId: checkResult.seniorId });
  };

  const handleConsentSaved = () => {
    go(STEPS.CONSENT_COMPLETE, { isNewConsent: true });
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <div className={styles.header}>
          <button className={styles.closeBtn} onClick={onClose} aria-label="닫기">×</button>
        </div>
        <div className={styles.body}>
          {state.currentStep === STEPS.IDENTIFY && (
            <IdentifyStep
              onDone={handleIdentifyDone}
              onAddSelfConsent={(seniorInfo, seniorId) =>
                go(STEPS.SELF_CONSENT_FORM, { seniorInfo, seniorId })
              }
              onSkip={onClose}
            />
          )}
          {state.currentStep === STEPS.CONSENT_TYPE && (
            <ConsentTypeStep
              onSelectSelf={() => go(STEPS.SELF_CONSENT_FORM)}
              onSelectGuardian={() => go(STEPS.GUARDIAN_CONSENT_FORM)}
            />
          )}
          {state.currentStep === STEPS.SELF_CONSENT_FORM && (
            <SelfConsentFormStep
              seniorInfo={state.seniorInfo}
              seniorId={state.seniorId}
              onDone={handleConsentSaved}
            />
          )}
          {state.currentStep === STEPS.GUARDIAN_CONSENT_FORM && (
            <GuardianConsentFormStep
              seniorInfo={state.seniorInfo}
              seniorId={state.seniorId}
              onDone={handleConsentSaved}
            />
          )}
          {state.currentStep === STEPS.CONSENT_COMPLETE && (
            <ConsentCompleteStep
              isNewConsent={state.isNewConsent}
              onClose={onClose}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export { STEPS };
export default FlowModal;
